export function BrandDescription({
    text = ''
}) {
    return (
        <div className="brand-description">
            <div className="brand-description__text">{text}</div>
        </div>
    );
}
